var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "support cases") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.164,5.014l-24-4a1,1,0,0,0-.328,0l-24,4A1,1,0,0,0,7,6V36c0,7.7,4.3,14.81,12.422,20.566a51.914,51.914,0,0,0,12.262,6.382.986.986,0,0,0,.632,0,51.914,51.914,0,0,0,12.262-6.382C52.7,50.81,57,43.7,57,36V6A1,1,0,0,0,56.164,5.014ZM29.113,41.941,18.172,31,21,28.172l7.887,7.887,15.9-18.546,3.037,2.6Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportCases);
export default __webpack_public_path__ + "static/media/support-cases.db8820b1eb643319fb4b226e0cab92a4.svg";
export { ForwardRef as ReactComponent };